const HEADER_HEIGHT = 60

export const smoothScrollTo = (href: string) => {
  if (!href.startsWith('#')) return

  const targetElement = document.querySelector(href)
  if (!targetElement) return

  const offsetTop = (targetElement as HTMLElement).offsetTop - HEADER_HEIGHT
  window.scrollTo({
    top: offsetTop,
    behavior: 'smooth',
  })
}
